export default "__VITE_ASSET__BxIAapc3__"